// import { nullableTypeAnnotation } from "babel-types";

export const initialState = {
  //V2 Data: States
  contactSent: null,
  cpus: null,
  format: null,
  loading: null,
  newsPosts: null,
  recordings: null,
  selectedUnit: null,
  sortingResults: null,
  selectednullableTypeAnnotationsult: null,
  selectedStudyName: null,
  selectedSorterName: null,
  sliderValue: {average:null, count: null},
  sorters: null,
  stats: null,
  studies: null,
  studySets: null,
  studyAnalysisResults: null
};
